import script from "./VehicleListingsNewlyAdded.vue?vue&type=script&lang=js"
export * from "./VehicleListingsNewlyAdded.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__